import { MathSinIcon } from './MathSinIcon';

/**
 * author: Michael Irigoyen
 * id CB473E87-BD2F-4416-A36E-6C4C12194D14
 * name math-sin
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/math-sin.svg
 * tags
 * - Math 
 */
export const MathsSinIcon = MathSinIcon;
export default MathsSinIcon